"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function VaultLeaveIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M12.8,9.082l1.522.7a.416.416,0,0,0,.342,0l5.983-2.742a.41.41,0,0,0,0-.747L13.133,2.948a.409.409,0,0,0-.576.374V8.709A.411.411,0,0,0,12.8,9.082Z" }),
        react_1.default.createElement("path", { d: "M10.406,2.948,2.9,6.291a.41.41,0,0,0,0,.747L8.881,9.78a.414.414,0,0,0,.341,0l1.522-.7a.411.411,0,0,0,.239-.372V3.322A.41.41,0,0,0,10.406,2.948Z" }),
        react_1.default.createElement("path", { d: "M10.423,12,1.307,7.825a.857.857,0,0,0-.814.058A.848.848,0,0,0,.1,8.6v7.578a.851.851,0,0,0,.5.777l9.117,4.061a.834.834,0,0,0,.345.074.85.85,0,0,0,.85-.85V12.777A.849.849,0,0,0,10.423,12Zm-1.2,6.925L1.8,15.625v-5.7l7.417,3.4Z" }),
        react_1.default.createElement("path", { d: "M23.648,13.825,19.776,9.953l-1.2,1.2L21,13.576H13.876v1.7H21L18.574,17.7l1.2,1.2,3.872-3.872a.85.85,0,0,0,0-1.2Z" })));
}
exports.default = VaultLeaveIcon;
